(function() {
	const canvas = document.getElementById('fluidCanvas');
	const wrapper = document.getElementById('saitriqEngine');
	if (!canvas || !wrapper) return;
	const ctx = canvas.getContext('2d', {
		alpha: true,
		desynchronized: true
	});
	let width = canvas.width = window.innerWidth;
	let height = canvas.height = window.innerHeight;
	let particles = [];
	let animationFrame;
	const mouse = {
		x: width / 2,
		y: height / 2,
		px: width / 2,
		py: height / 2,
		vx: 0,
		vy: 0,
		active: false
	};
	const drag = 0.96;
	let currentAccent1 = "#2563eb";
	let currentAccent2 = "#ff6a00";
	let rgbAccent1 = hexToRgb(currentAccent1);
	let rgbAccent2 = hexToRgb(currentAccent2);

	function hexToRgb(hex) {
		if (!hex || hex[0] !== "#") {
			return {
				r: 37,
				g: 99,
				b: 235
			};
		}
		return {
			r: parseInt(hex.substring(1, 3), 16),
			g: parseInt(hex.substring(3, 5), 16),
			b: parseInt(hex.substring(5, 7), 16)
		};
	}
	class DustParticle {
		constructor() {
			this.reset();
		}
		reset() {
			this.x = Math.random() * width;
			this.y = Math.random() * height;
			this.radius = Math.random() * 1.2 + 0.4;
			this.vx = (Math.random() - 0.5) * 0.18;
			this.vy = (Math.random() - 0.5) * 0.18 - 0.04;
			this.alpha = Math.random() * 0.25 + 0.12;
			this.colorSelector = Math.random() > 0.5;
		}
		update() {
			if (mouse.active) {
				const dx = this.x - mouse.x;
				const dy = this.y - mouse.y;
				const distance = Math.sqrt(dx * dx + dy * dy);
				if (distance < 120) {
					const power = (120 - distance) / 120;
					this.vx += mouse.vx * power * 0.08;
					this.vy += mouse.vy * power * 0.08;
				}
			}
			this.vx *= drag;
			this.vy *= drag;
			this.x += this.vx;
			this.y += this.vy;
			if (this.x < -20 || this.x > width + 20 || this.y < -20 || this.y > height + 20) {
				this.reset();
			}
		}
		draw() {
			const color = this.colorSelector ? rgbAccent1 : rgbAccent2;
			ctx.beginPath();
			ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
			ctx.fillStyle = `rgba(${color.r},${color.g},${color.b},${this.alpha})`;
			ctx.fill();
		}
	}

	function initParticles() {
		particles = [];
		let density;
		if (window.innerWidth < 768) {
			density = 200;
		} else {
			density = Math.min(Math.floor(width * height / 12000), 180);
		}
		for (let i = 0; i < density; i++) {
			particles.push(new DustParticle());
		}
	}
	let bgColor = "rgba(0,0,0,0.15)";

	function updateBackground() {
		const style = window.getComputedStyle(wrapper);
		const bg = style.backgroundColor;
		if (bg.includes("rgb")) {
			bgColor = bg.replace("rgb", "rgba").replace(")", ",0.18)");
		}
	}

	function animate() {
		if (document.hidden) {
			animationFrame = requestAnimationFrame(animate);
			return;
		}
		ctx.fillStyle = bgColor;
		ctx.fillRect(0, 0, width, height);
		if (mouse.active) {
			mouse.vx = (mouse.x - mouse.px) * 0.85;
			mouse.vy = (mouse.y - mouse.py) * 0.85;
			mouse.px = mouse.x;
			mouse.py = mouse.y;
		}
		particles.forEach(p => {
			p.update();
			p.draw();
		});
		animationFrame = requestAnimationFrame(animate);
	}
	/* Theme Switch */
	document.querySelectorAll('.swatch-btn').forEach(button => {
		button.addEventListener("click",
			() => {
				document.querySelectorAll('.swatch-btn').forEach(btn => btn.classList.remove('active'));
				button.classList.add('active');
				wrapper.dataset.activeTheme = button.dataset.theme;
				const styles = getComputedStyle(wrapper);
				currentAccent1 = styles.getPropertyValue('--accent-1').trim() || currentAccent1;
				currentAccent2 = styles.getPropertyValue('--accent-2').trim() || currentAccent2;
				rgbAccent1 = hexToRgb(currentAccent1);
				rgbAccent2 = hexToRgb(currentAccent2);
			}, {
				passive: true
			});
	});
	/* Mouse Interaction */
	canvas.addEventListener("mousemove", e => {
		const rect = canvas.getBoundingClientRect();
		mouse.x = e.clientX - rect.left;
		mouse.y = e.clientY - rect.top;
		mouse.active = true;
	}, {
		passive: true
	});
	canvas.addEventListener("mouseleave",
		() => {
			mouse.active = false;
			mouse.vx = 0;
			mouse.vy = 0;
		}, {
			passive: true
		});
	window.addEventListener("resize",
		() => {
			width = canvas.width = window.innerWidth;
			height = canvas.height = window.innerHeight;
			initParticles();
		}, {
			passive: true
		});
	updateBackground();
	if ("requestIdleCallback" in window) {
		requestIdleCallback(() => {
			initParticles();
			animate();
		});
	} else {
		initParticles();
		animate();
	}
})();
/* ==========================
   QUOTE MODAL CONTROLLER
========================== */
(function() {
	const modal = document.getElementById("quoteModalOverlay");
	if (!modal) return;
	const openBtn = document.getElementById("openQuoteModal");
	const closeBtn = document.getElementById("closeQuoteModal");

	function cleanURL() {
		const url = new URL(window.location.href);
		url.searchParams.delete("contact_posted");
		url.hash = "";
		history.replaceState({}, document.title, url.pathname + url.search);
	}

	function resetForm() {
		modal.querySelectorAll(".form-status").forEach(el => el.remove());
		const form = modal.querySelector(".quote-form");
		if (form) {
			form.reset();
		}
	}

	function openModal() {
		modal.classList.add("active");
	}

	function closeModal() {
		modal.classList.remove("active");
		cleanURL();
		setTimeout(resetForm, 400);
	}
	const params = new URLSearchParams(window.location.search);
	if (params.get("contact_posted") === "true" || location.hash === "#contact_form") {
		openModal();
	}
	openBtn?.addEventListener("click", openModal);
	closeBtn?.addEventListener("click", closeModal);
	modal.addEventListener("click", e => {
		if (e.target === modal) {
			closeModal();
		}
	});
	window.addEventListener("keydown", e => {
		if (e.key === "Escape" && modal.classList.contains("active")) {
			closeModal();
		}
	});
})();